import { Button } from "@choose/ui/button";
import { Separator } from "@choose/ui/separator";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { SnippetForm } from "~/components/common/settings/snippets/snippet-form";

export const Route = createFileRoute(
  "/_auth/_app_shell/_settings-navigation/settings/snippets/add",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <title>{`${t("settings.snippets.title")} - ${t("app_name")}`}</title>
      <div className="bg-background w-full overflow-auto">
        <div className="m-auto max-w-2xl p-8">
          <header className="mt-14">
            <Button
              variant="ghost"
              size="sm"
              className="-mx-3 mb-4"
              nativeButton={false}
              render={
                <Link to="/settings/snippets">
                  <ArrowLeftIcon />
                  <span>{t("settings.snippets.all_snippets")}</span>
                </Link>
              }
            />

            <h1 className="text-2xl">{t("settings.snippets.add_snippet")}</h1>
          </header>
          <Separator className="my-6" />
          <SnippetForm />
        </div>
      </div>
    </>
  );
}
